const middleware = {}

middleware['intermediary-auth'] = require('../middleware/intermediary-auth.js')
middleware['intermediary-auth'] = middleware['intermediary-auth'].default || middleware['intermediary-auth']

export default middleware
